// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { QAReadabilityService } from '@client/app/blocks/service/qa-readability/qareadability.service';

@Component({
    selector: 'qa-summary-readability',
    standalone: false,
    template: `
        <div class="card panel-monsido-card readability-panel" *ngIf="mostUsesReadabilityLevel !== null">
            <mon-panel-header pHeader="{{ 'Readability' | translate }}"></mon-panel-header>
            <div class="card-body">
                <mon-spinner [loading]="loading">
                    <table class="table table-hover table-fixed remove-border-on-first-row mb-0">
                        <tbody>
                        <tr class="cursor-pointer">
                            <td>
                                <a class="readability-link"
                                   uiSref="base.customer.domain.qa.readability.dashboard"
                                   [attr.aria-label]="'Readability' | translate">
                                    <div class="d-flex align-items-center">
                                        <div class="pl-1">
                                            <span class="fas fa-eye fa-3x text-link"></span>
                                        </div>
                                        <div class="pl-4">
                                            <span class="text-grey" translate>Most of your pages have the readability level</span>
                                            <h4 class="font-weight-300 my-0 font-size-1-5 mt-2 mb-3">
                                                {{ getTranslatedReadabilityLevel() }}
                                            </h4>
                                            <span class="text-grey"
                                                  translate
                                                  [translate-args]="{pageCount: getFormattedPageCount()}">
                                            Affects [[pageCount]] pages
                                        </span>
                                        </div>
                                    </div>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class QaSummaryReadabilityComponent implements OnInit {
    @Input() readabilitySummary: any;
    @Input() progress: any;
    @Input() loading: any;

    mostUsesReadabilityLevel: any = null;

    constructor (
        private stateService: StateService,
        private qaReadabilityService: QAReadabilityService,
    ) {}

    ngOnInit (): void {
        this.mostUsesReadabilityLevel = null;
        this.setupReadability();
    }

    private setupReadability (): void {
        this.progress.then(() => {
            setTimeout(() => {
                if (this.readabilitySummary && typeof this.readabilitySummary === 'object') {
                    if (
                        this.readabilitySummary.distribution &&
                        Object.keys(this.readabilitySummary.distribution).length > 0
                    ) {
                        const distribution = Object.keys(this.readabilitySummary.distribution).map((key) => {
                            return { name: key, page_count: this.readabilitySummary.distribution[key] };
                        });

                        distribution.sort((a, b) => {
                            return a.page_count < b.page_count ? 1 : a.page_count > b.page_count ? -1 : 0;
                        });
                        this.mostUsesReadabilityLevel = distribution[0];
                    }
                }
            }, 100);
        }, () => {
            // Handle error case
        });
    }

    getTranslatedReadabilityLevel (): string {
        if (!this.mostUsesReadabilityLevel || !this.readabilitySummary) {
            return '';
        }
        return this.qaReadabilityService.getTranslationScore(
            this.mostUsesReadabilityLevel.name,
            this.readabilitySummary.test,
        );
    }

    getFormattedPageCount (): string {
        if (!this.mostUsesReadabilityLevel) {
            return '0';
        }
        // Using string concatenation to format the number, similar to how monNumber pipe would work
        return this.mostUsesReadabilityLevel.page_count?.toLocaleString() || '0';
    }
}
